"use client";
import {
  image_default
} from "./chunk-VKW4DPLJ.mjs";
import {
  useImage
} from "./chunk-7THIFN6D.mjs";
export {
  image_default as Image,
  useImage
};
